class relatedColors extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this._initRelatedColors();
    }
  
    async _initRelatedColors() {
      const currentProductHandle = this.getAttribute('data-handle');
      const relatedColorsTag = this.getAttribute('data-tag');
      const targetURL = `/collections/shop-all/${relatedColorsTag}/?view=json`;
      const relatedColorsJSON = await this._getRelatedColorJSON(targetURL);
      let relatedColorsMarkup = '';
  
      if (relatedColorsJSON.length <= 1) {
        return;
      }
  
      relatedColorsJSON.forEach((product) => {
        
        if (product.handle != currentProductHandle) {
          relatedColorsMarkup = `${relatedColorsMarkup}<a href="${product.url}" class="product-related-colors__related" aria-label="${product.color}" style="background-color: ${product.hex_color};"></a>`
        }
      })
      
      this.insertAdjacentHTML('beforeend', relatedColorsMarkup)
      this.classList.remove('hidden')
    }
  
    _getRelatedColorJSON(url) {
      return fetch(url)
        .then(response => response.text())
        .then((text) => {
          const html = text;
          const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
          const JSONcontainer = parsedHTML.querySelector('[js-collection-json]');
          const parsedJSON = JSON.parse(JSONcontainer.innerHTML);
          return parsedJSON;
        })
    }
  
  }
  
  customElements.define("related-colors", relatedColors);